import styles from "./index.module.css";
import Replay from "../../assets/images/Replay.png";
import img6 from "../../assets/images/solar-study-favicon.png";
import { useAppSelector } from "../../store/store";
import { useGenerateBridgeTokenMutation } from "../../services/api";
import { config } from "../../configs";
import clsx from "clsx";
import ResouceLibary4 from "../../assets/images/ResourceLibraryClean.png";
interface IAdditionalResources {
  openAnimatedOverview: (url: string) => void;
}

const solarStudyUrl =
  config?.REACT_APP_SOLAR_STUDY_URL || "https://solar.study";

const AdditionalResources = ({
  openAnimatedOverview,
}: IAdditionalResources) => {
  const solarStudyInvite = useAppSelector(
    (state) => state.login.solarStudyInvite
  );
  const userEmail = useAppSelector((state) => state.login.email);
  const [generateBridgeToken] = useGenerateBridgeTokenMutation();

  const handleVideoModal = (url: string) => {
    openAnimatedOverview(url);
  };

  const handleSolarStudyRedirect = async (): Promise<void> => {
    try {
      if (!userEmail) {
        window.open(solarStudyUrl, "_blank");
        return;
      }

      const response = await generateBridgeToken(userEmail).unwrap();

      if (response.success && response.data?.bridgeToken) {
        window.open(
          `${solarStudyUrl}/cross-auth?token=${response.data.bridgeToken}`,
          "_blank"
        );
      } else {
        window.open(solarStudyUrl, "_blank");
      }
    } catch (error) {
      console.error(
        "Error redirecting to Solar Study:",
        error instanceof Error ? error.message : "Unknown error"
      );
      window.open(solarStudyUrl, "_blank");
    }
  };

  return (
    <div className={clsx(styles.tile, styles.customTile)}>
      <h2 className={styles.heading}>Additional Resources</h2>
      <div className="grid gap-y-3 m-2 grid-cols-3">
        <div
          className="flex flex-col items-center cursor-pointer pt-2  place-content-center "
          onClick={() =>
            window.open(
              "https://learn.zohopublic.com/external/manual/inception-financial-knowledge-base?p=bf80f12473e7535675946df5b62034cc7fb015d0047609dbd60961acab25116f",
              "_blank"
            )
          }
        >
          <img className="h-[50px]" src={ResouceLibary4} alt="" />
          <h3 className="text-center text-[10px] mt-4">KNOWLEDGE CENTER</h3>
        </div>
        {solarStudyInvite && (
          <div
            className="flex flex-col items-center justify-center cursor-pointer place-content-center h-[70%]"
            onClick={handleSolarStudyRedirect}
          >
            <img className="h-[60px] my-1" src={img6} alt="Solar Study" />
            <h3 className="text-center text-[10px]">SOLAR STUDY</h3>
          </div>
        )}

        <div
          className="flex flex-col items-center cursor-pointer"
          onClick={() =>
            handleVideoModal(
              "https://vimeo.com/1046949461/2c31de84e8?share=copy"
            )
          }
        >
          <img className={styles.replay} src={Replay} alt="" />
          <h3 className={styles.tileheading}>
            MATERIAL PARTICIPATION OVERVIEW
          </h3>
        </div>
      </div>
    </div>
  );
};

export default AdditionalResources;
